import script from "./tags.vue?vue&type=script&setup=true&lang=js"
export * from "./tags.vue?vue&type=script&setup=true&lang=js"

import "./tags.vue?vue&type=style&index=0&id=40c4cea1&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c4cea1"]])

export default __exports__